module.exports = __webpack_public_path__ + "img/grade16.75ef0556.png";